import { UserType } from 'types/user';
import api from './api';

export class CandidateService {
  static getGeneral = () => {
    return api.get<UserType>('/profile');
  };

  static updateUser = (user: UserType) => {
    return api.put('/profile', {
      abstract: user.abstract,
      additionalInfo: user.additionalInfo,
      address: user.address,
      addressNumber: user.addressNumber,
      birthDate: user.birthDate,
      socialNetworks: user.socialNetworks,
      burgh: user.burgh,
      cellPhone: user.cellPhone,
      city: user.city,
      country: user.country,
      currentPosition: user.currentPosition,
      document: user.document,
      email: user.email,
      genre: user.genre,
      headline: user.headline,
      homePhone: user.homePhone,
      name: user.name,
      surname: user.surname,
      zipCode: user.zipCode
    });
  };

  static acceptTerms = (version: string) => {
    return api.patch('/users/policy', { version });
  };

  static createCompany = (document: string) => {
    return api.post('/authentication/company-signup', { document });
  };
}
